import type { Ich } from "../../api/typen";

/** Merker in `localStorage`: Liste der Konten (Nutzer-IDs), die die Begrüßung auf diesem Gerät gesehen haben. Ob ein Konto
 *  in der Beta ist, sagt allein der Server (`ich.beta`); der Merker regelt nur, dass sie einmal erscheint. */
const BEGRUESST = "pg-beta-begruesst";

export function begruesst(): string[] {
  try {
    const roh: unknown = JSON.parse(localStorage.getItem(BEGRUESST) ?? "[]");
    return Array.isArray(roh) ? roh.filter((x): x is string => typeof x === "string") : [];
  } catch {
    return [];
  }
}

export function begruesstMerken(nutzer: string): void {
  try {
    const liste = begruesst();
    if (!liste.includes(nutzer)) localStorage.setItem(BEGRUESST, JSON.stringify([...liste, nutzer].slice(-20)));
  } catch {
    /* ohne Speicher erscheint sie beim nächsten Start noch einmal */
  }
}

/** W82 Beta-W2 (D-704): Wartezeit zwischen „Verstanden“ und dem Start des Auftritts der Startseite, wie nach dem Entsperren:
 *  das Blatt ist zu, erst dann beginnt der Auftritt. Wert `--pg-dur-slow` (tokens.css, Sheets). */
export const AUFTRITT_NACH_BEGRUESSUNG_MS = 280;

/** Kommt die Beta-Begrüßung auf diesem Gerät noch (dieselben dauernden Bedingungen wie `BetaBegruessung`, ohne die kurzen:
 *  offenes Blatt, Meldung)? Die Startseite fragt es beim ersten Rendern und hält ihren Auftritt bis zum Schließen an. */
export function begruessungKommt(ich: Ich | null | undefined, pfad: string): boolean {
  const nutzer = ich?.nutzer?.id;
  return Boolean(nutzer && ich?.beta === true && ich.eingefuehrt !== false && !ich.nutzer?.nutzung_hinweis_offen && pfad !== "/willkommen" && !begruesst().includes(nutzer));
}

const hoerer = new Set<() => void>();

/** Die Begrüßung ist geschlossen („Verstanden“). */
export function begruessungGeschlossen(): void {
  for (const h of [...hoerer]) h();
}

/** Ruft `fertig` einmal, sobald die Begrüßung geschlossen ist; gibt das Abmelden zurück. */
export function aufBegruessungWarten(fertig: () => void): () => void {
  const h = () => {
    hoerer.delete(h);
    fertig();
  };
  hoerer.add(h);
  return () => void hoerer.delete(h);
}
